<div class="page-content">
    <p-panel [header]="'Files at ' + userFileCrud.currentPathRootResolved" class="no-x-padding">
        <app-user-file-crud #userFileCrud></app-user-file-crud>
    </p-panel>
</div>
